import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./../../assets/css/responsive.css";
import "./../../assets/css/style.css";
import logoPath from "./../../assets/image/logo.png";
import PoolContainer from "./Pool";
import EarnContainer from "./Earn";
import S1EarnContainer from "./S1Earn";
// import S2EarnContainer from "./S2Earn";
import { getWeb3 } from './web/util.js'
import { Box, Link, Modal, Fade, makeStyles } from "@material-ui/core";
import Joyride,{STATUS}from "react-joyride";
import useCookie from "react-use-cookie";
import Web3 from 'web3';

const useStyles = makeStyles((theme) => ({
  maxInput: {
    float: "right",
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center"
  },
}));

const DashboardContainer = () => {
  const classes = useStyles();
  const [tronWeb, setTronWeb] = useState(null);
  const [active, setActive] = useState(0);
  const [currentCount, setCount] = useState(100);
  const [wall, setWall] = useState(true)
  const [beenHere, setBeenHere] = useCookie('beenHere',"no");
  const earnRef = useRef(null);
  const [web3Con, setweb3Con] = useState(null);

  const timer = async () => {

    let curtronWeb = getWeb3();
    if (curtronWeb) {
      setCount(0);
      setTronWeb(curtronWeb);
      if(curtronWeb) {
        if(!window.web3Con){
          let web3Con = new Web3(curtronWeb);
          window.web3Con = web3Con;
          setweb3Con(web3Con);
        }
        let accounts = await window.web3Con.eth.getAccounts();
        if(!accounts.length)
          setWall(true);
        else{
          const networkId = await window.web3Con.eth.net.getId();
          if (networkId !== 56) {
            setWall(true)
          }
          else
            setWall(false)
        }
      } else {
        setWall(true)
      }
    }
    else
      setCount(currentCount - 1);
  }

  async function walletconnect(){
    await window.ethereum.request({ method: 'eth_requestAccounts' });
    const networkId = await window.web3Con.eth.net.getId();
    if (networkId !== 56) {
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: '0x38' }],    // mainnet 0x38, testnet: 0x61
        });
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [{
                chainId: '0x38', rpcUrls: ['https://bsc-dataseed1.binance.org/'], chainName: 'BSC Mainnet',
                nativeCurrency: {
                  name: 'BNB',
                  symbol: 'BNB', // 2-6 characters long
                  decimals: 18
                }, blockExplorerUrls: ['https://bscscan.com/']
              }],
            });
          } catch (addError) {
            // handle "add" error
          }
        }
      }
    }
    setWall(false)
  }

  useEffect(
    () => {
      if (currentCount <= 0) {
        return;
      }
      const id = setInterval(timer, 1000);
      //return () => clearInterval(id);
    },
    [currentCount]
  );

  const joyrideCallback = ({action,index,status,type}) => {
    if(status === STATUS.FINISHED) {
      setBeenHere("yes")
      earnRef.current.click();
    }
  }

  const steps = [
    {
      target: ".pool-tab",
      content: "Add liquidity by pairing your STM with USDT. In return you will get Liquidity tokens that you can stake and earn more STM. You can remove liquidity at any time."
    },
    {
      target: ".earn-tab",
      content: "Lock your liquidity tokens here and earn more STM. Dont worry, you can unlock them and get your Liquidity tokens back at any time."
    },
    // {
    //   target: ".s2-tab",
    //   content: "Unstake your liquidity tokens and get the reward tokens in Season 2 here."
    // },
    {
      target: ".s1-tab",
      content: "Unstake your liquidity tokens and get the reward tokens in Season 1 here."
    },
  ]

  return (
    <>
    <Modal
      open={wall}
      onClose={() => (true)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      >
      <Fade in={wall}>
        <div className={classes.paper} onClick={walletconnect}>
          <h2 id="transition-modal-title">Connect Metamask to use</h2>
          <p id="transition-modal-description">This website requires MetaMask.Click to connect Metamask</p>
        
        </div>
      </Fade>
    </Modal>
    <Box className="main-wrapper inner-page-wrapper minimize-wrp">
      {(beenHere === "no") && <Joyride debug={true} callback={joyrideCallback} steps={steps} run={true} continuous={true}/>}

      <link
        rel="stylesheet"
        href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
        integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
        crossOrigin="anonymous"
      />
      <Box className="logo-wrp">
        <img src={logoPath} alt="logo" />
      </Box>

      <section className="tabs-wrp">
        <ul className="nav nav-tabs">
          <li className={active === 0 ? "active pool-tab" : "pool-tab"}>
            <Link
              data-toggle="tab"
              href="#Pool"
              onClick={(e) => {
                setActive(0);
              }}
            >
              Pool
            </Link>
          </li>
          <li className={active === 1 ? "active earn-tab" : "earn-tab"}>
            <Link
              id="earnLink"
              data-toggle="tab"
              href="#Earn"
              ref={earnRef}
              onClick={(e) => {
                setActive(1);
              }}
            >
              Earn
            </Link>
          </li>
          <li className={active === 2 ? "active s1-tab" : "s1-tab"}>
            <Link
              id="s1earnLink"
              data-toggle="tab"
              href="#S1earn"
              ref={earnRef}
              onClick={(e) => {
                setActive(2);
              }}
            >
              Season 1
            </Link>
          </li>
          {/* <li className={active === 3 ? "active s1-tab" : "s1-tab"}>
            <Link
              id="earnLink"
              data-toggle="tab"
              href="#S1earn"
              ref={earnRef}
              onClick={(e) => {
                setActive(3);
              }}
            >
              Season 1
            </Link>
          </li> */}
        </ul>

        <Box className="tab-content">
        {active === 0 ? (
            <PoolContainer />
          ) : active === 1 ?(
            <EarnContainer />
          ) : (
            <S1EarnContainer />
          )}
        </Box>
      </section>
    </Box>
    </>
  );
};

export default DashboardContainer;